// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/home.css
// module id = 2012
// module chunks = 2